module.exports = __webpack_public_path__ + "img/photo_uploading.926f4028.gif";